import { PERMISSION_KEYS, PERMISSIONS, ROLES } from "constants/roles";

const validPermissionKeys = Object.values(PERMISSION_KEYS);
const validRoleIds = Object.values(ROLES);

/**
 * Check if a role has access to a permission key
 * @param {string} permissionKey
 * @param {number} roleId
 * @returns {boolean}
 */
export function canAccess(permissionKey, roleId) {
    if (typeof roleId !== "number" || !validRoleIds.includes(roleId)) {
        console.warn("[PermissionsService] Invalid or missing role:", roleId);
        return false;
    }

    if (!validPermissionKeys.includes(permissionKey)) {
        console.warn(
            `[PermissionsService] Unknown permission key: ${permissionKey}`,
        );
        return false;
    }

    const allowedRoles = PERMISSIONS[permissionKey];
    if (!Array.isArray(allowedRoles)) {
        console.warn(
            `[PermissionsService] No role list found for permission: ${permissionKey}`,
        );
        return false;
    }

    return allowedRoles.includes(roleId);
}
